import { render } from "./chat_title.vue?vue&type=template&id=47293420"
import script from "./chat_title.js?vue&type=script&lang=js"
export * from "./chat_title.js?vue&type=script&lang=js"

import "./chat_title.vue?vue&type=style&index=0&id=47293420&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__